import React, { useContext } from 'react'
import ImageNotFound from '../../assets/image-not-found.jpg'
import EditIcon from '../../assets/edit-icon.svg'
import TrashIconLight from '../../assets/trash-icon-light.svg'
import UploadIcon from '../../assets/upload-icon.svg'
import Icon8K from '../../assets/videoQuality/8k-icon.png'
import Icon4K from '../../assets/videoQuality/4k-icon.png'
import Icon2K from '../../assets/videoQuality/2k-icon.png'
import Icon1080P from '../../assets/videoQuality/1080p-icon.png'
import Icon720P from '../../assets/videoQuality/720p-icon.png'
import Icon480P from '../../assets/videoQuality/480p-icon.png'
import Icon360P from '../../assets/videoQuality/360p-icon.png'
import TrailerOverlayIcon from '../../assets/trailer-overlay-play-icon.svg'
import { GlobalContext } from 'src/views/context/GlobalState'
import './assetSelector.scss'
import { formatBytes, getVideoThumbnail } from 'src/views/utils/helper'
import { CButton } from '@coreui/react'
import moment from 'moment'
import { isEmpty } from 'lodash'

const AssetSelectorBox = ({ data, onSelect, onEdit, onDelete, disabled = false }) => {
  const { userSessionObj } = useContext(GlobalContext)
  const ResolutionsIcon = {
    360: Icon360P,
    480: Icon480P,
    720: Icon720P,
    1080: Icon1080P,
    2048: Icon2K,
    3840: Icon4K,
    7680: Icon8K,
  }
  return (
    <div className="content-upload-box d-flex position-relative">
      <div
        style={{
          width: '14.375vw',
          height: '8.593vw',
          background: disabled ? '#eee' : '#ffffff',
          border: 'solid 0.5px #707070',
          borderRadius: '2px',
        }}
        className="d-flex justify-content-center align-items-center"
      >
        <div
          style={{
            width: '13.125vw',
            height: '7.4vw',
            background: disabled ? '#eee' : '#ffffff',
            border: 'solid 1px #707070',
          }}
          className="d-flex flex-column justify-content-center align-items-center"
        >
          {data.asset_id ? (
            <div className="w-100 h-100 position-relative">
              <img
                className="w-100 h-100"
                src={getVideoThumbnail(userSessionObj.session_data.cf_domain_name, data.asset_id)}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null // prevents looping
                  currentTarget.src = ImageNotFound
                }}
                alt={'trailerAsset'}
              />
              <img
                className="position-absolute"
                src={TrailerOverlayIcon}
                style={{
                  top: '32%',
                  left: '40%',

                  margin: 'auto',
                  width: '2.86vw',
                  height: '2.86vw',
                }}
              />
            </div>
          ) : (
            <div>
              <div>
                <img
                  src={UploadIcon}
                  style={{
                    width: `1rem`,
                    height: `1rem`,
                  }}
                  className="mx-1"
                  alt="upload-icon"
                />
                <span style={{ color: '#707070', fontSize: '11px' }}>Upload Content</span>
              </div>
              <div>
                <CButton
                  className="text-white w-100 border-0"
                  style={{
                    marginTop: `0.5vw`,
                    background: disabled ? '#a8a8a8' : '#20211c',
                    fontSize: '11px',
                  }}
                  onClick={onSelect}
                  disabled={disabled}
                >
                  Select Video
                </CButton>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{ width: '54%', marginLeft: '7.5%' }}
        className="ml-4 mr-5 flex flex-column   mt-1"
      >
        <span
          style={{
            fontSize: '1vw',
            fontWeight: 550,
            width: '100%',
            color: `${data?.file_name ? '' : '#707070'}`,
            cursor: 'default',
          }}
          className="line-clamp-1"
          title={data?.file_name}
        >
          {data?.file_name || `Lorem ipsum dolor sit amet`}
        </span>
        <hr style={{ marginTop: '1.25vw' }} className=" mb-2" />
        <div className="d-flex w-100">
          <div className=" w-50">
            <p
              style={{
                fontSize: '0.73vw',
                color: '#707070',
                fontWeight: '500',
                marginBottom: '0.6vw',
              }}
              className=""
            >
              Size:{` `}
              <b style={{ color: '#000' }}>
                {data?.file_metadata?.file_size ? formatBytes(data?.file_metadata?.file_size) : ''}
              </b>
            </p>
            <p
              style={{
                fontSize: '0.73vw',
                color: '#707070',
                fontWeight: '500',
                marginBottom: '0.6vw',
              }}
              className=""
            >
              Added to Content:{` `}
              <b style={{ color: '#000' }}>
                {!isEmpty(data) ? (data?.is_added_to_content ? 'Yes' : 'No') : ''}
              </b>
            </p>
            <p style={{ fontSize: '0.73vw', color: '#707070', fontWeight: '500' }} className="mb-0">
              Upload Date:{` `}
              <b style={{ color: '#000' }}>
                {data?.updated_at ? moment.unix(data?.updated_at).format('DD MMMM YYYY') : ''}
              </b>
            </p>
          </div>
          <div className=" w-50">
            <p style={{ fontSize: '0.73vw', color: '#707070', fontWeight: '500' }} className="mb-2">
              Resolutions Available:
            </p>
            <div>
              {!isEmpty(data?.progress) &&
                Object.keys(data?.progress).map((key, index) => {
                  return (
                    data?.progress[key] === 100 && (
                      <img
                        src={ResolutionsIcon[key]}
                        style={{ height: '0.87vw', width: 'fit-content' }}
                        className={`${index && 'ml-2'} `}
                      />
                    )
                  )
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="position-absolute right-2 flex">
        <div
          className={` mx-3 rounded-full flex justify-center items-center ${
            disabled ? '' : 'cursor-pointer'
          } `}
          style={{
            boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)',
            border: 'solid 0.5px #fff',
            height: '26px',
            width: '26px',
            background: disabled ? '#a8a8a8' : '#20211c',
          }}
        >
          <img
            src={EditIcon}
            style={{
              width: '14px',
              height: '14px',
            }}
            className=""
            alt="editicon"
            onClick={disabled ? () => {} : onEdit}
          />
        </div>
        <div
          className={` mx-2 rounded-full flex justify-center items-center ${
            disabled ? '' : 'cursor-pointer'
          }`}
          style={{
            boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)',
            border: 'solid 0.5px #fff',
            height: '26px',
            width: '26px',
            background: disabled ? '#a8a8a8' : '#20211c',
          }}
        >
          <img
            src={TrashIconLight}
            style={{
              width: '14px',
              height: '14px',
            }}
            className=""
            alt="TrashIconLight"
            onClick={disabled ? () => {} : onDelete}
          />
        </div>
      </div>
    </div>
  )
}

export default AssetSelectorBox
